<!--FastBI产品-->
<template>
  <div class="buyDialog">
    <el-dialog :before-close="restForm" :title="isAdd == 'triall' ? '试用产品' : '购买产品'" :visible.sync="visible"
      :close-on-click-modal="false" width="560px">
      <el-form :model="form" ref="form" :rules="formRules">
        <el-form-item :label-width="formLabelWidth" label="授权客户名称" prop="name">
          <el-input v-model="form.name" :disabled="isAdd === 'edit' ? true : false"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="授权码" prop="code">
          <el-input v-model="form.code" :disabled="isAdd === 'edit' ? true : false"></el-input>
        </el-form-item>
        <div v-if="isAdd != 'edit'">
          <el-form-item :label-width="formLabelWidth" label="授权码密码" prop="key">
            <el-input v-model="form.key"></el-input>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth" label="联系人" prop="contact_name">
            <el-input v-model="form.contact_name"></el-input>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth" label="联系人电话" prop="phone">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth" label="联系人邮箱" prop="email">
            <el-input v-model="form.email"></el-input>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth" label="选择版本" prop="fbi_edition">
            <el-select v-model="form.fbi_edition" value-key="id" filterable placeholder="请选择" @change="changeEditions">
              <el-option v-for="item in edittions" :key="item.id" :label="item.name" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item v-if="isAdd == 'edit'" :label-width="formLabelWidth" label="选择版本" prop="fbi_edition">
          <el-select v-model="form.fbi_edition" filterable placeholder="请选择" @change="changeEditions" :disabled="true">
            <el-option v-for="item in edittions" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <div v-if="isAdd != 'triall'">
          <el-form-item :label-width="formLabelWidth" label="购买方式" prop="buy_type">
            <el-radio-group v-model="form.buy_type" @change="buy_type_change">
              <el-radio :label="1">买断模式</el-radio>
              <el-radio :label="2">按年订阅</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <el-form-item :label-width="formLabelWidth" v-if="isAdd === 'triall' ||form.buy_type != 1" :label="isAdd === 'triall' ? '试用时长' : '购买时长'">

          <template v-if="isAdd != 'triall'">
            <el-input-number style="text-align: center;" size="small" v-model="form.new_months" :min="1" :max="100"
              :step="1"></el-input-number>
            <span style="margin-left: 10px;">年</span>
          </template>
          <template v-else>
            <el-select v-model="form.months" @change="changeBuyDate" filterable placeholder="请选择">
              <!-- <template v-if="isAdd != 'triall'">
                <el-option v-for="item in buyTime" :key="item.value" :label="item.name" :value="item.value">
                </el-option>
              </template> -->
              <!-- <template> -->
              <el-option :key="7" label="七天" :value="7"> </el-option>
              <el-option :key="15" label="十五天" :value="15"> </el-option>
              <el-option :key="30" label="一个月" :value="30"> </el-option>
              <!-- </template> -->
              <!-- <el-option v-if="isAdd == 'edit'" :key="0" label="只增购模块" :value="0"> -->
              <!-- </el-option> -->
            </el-select>
          </template>
        </el-form-item>

        <!-- <div class="block" v-if="this.isAdd == 'edit'">
            <div class="label">当前有效期 {{ this.form.expire_time }}</div>
            <div class="label">购买后有效期 {{ new_expire_time }}</div>
          </div> -->
        <!-- <div class="context">
            <p>增值模块</p>
            <el-table ref="elTable" :data="modules" style="width: 100%; margin-bottom: 20px" row-key="id" border @select="selectChange" @select-all="selectAllChange">
              <el-table-column type="selection" width="55" :selectable="checkSelctRow">
              </el-table-column>
              <el-table-column prop="name" label="模块名称" width="180">
              </el-table-column>
              <el-table-column label="授权信息">
                <template slot-scope="scope">
                  <span v-if="
                      currentSelectModuels.indexOf(scope.row.code) == -1 ||
                      !form.expire_time
                    "></span>
                  <span v-else-if="form.expire_time == '买断'">购买后有效期 {{ form.expire_time }}</span>
                  <span v-else>购买后有效期 {{ new_expire_time }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div> -->
        <!-- <div v-if="isAdd === 'triall'"> -->
        <el-form-item v-if="isAdd !== 'edit'" :label-width="formLabelWidth" label="备注" prop="note">
          <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="form.note">
          </el-input>
        </el-form-item>
        <!-- </div> -->
        <!-- <div v-if="isAdd != 'triall'">
          <el-form-item :label-width="formLabelWidth" label="支付方式" prop="pay_type">
            <el-radio-group v-model="form.pay_type">
              <el-radio :label="1">FastBI产品专用币优先</el-radio>
              <el-radio :label="2">通用币优先</el-radio>
            </el-radio-group>
          </el-form-item>
        </div> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <div class="price">订单:<span>¥10000</span></div> -->
        <el-button @click="cancel('form', (visible = false))">取 消</el-button>
        <el-button v-if="isAdd == 'triall'" class="primary" @click="triallClick">申请试用</el-button>
        <el-button v-else class="primary" @click="buyClick">预览价格</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  buyPrice,
  buy,
  modify_price,
  modify,
  getProductEditions,
  getProductModules,
  addTrail,
} from "@/api/auth";
import { payType } from "@/utils/dataDict";
import { payVerify } from "@/utils/pay";
export default {
  data() {
    return {
      new_expire_time: "",
      modifyId: null,
      isAdd: "add",
      currentBuyTime: null,
      payType,
      visible: false,
      formLabelWidth: "110px",
      form: {
        name: "",
        code: "",
        key: "",
        contact_name: "",
        phone: "",
        email: "",
        months: null,
        pay_type: 1,
        fbi_edition: "",
        modules: [],
        note: "",
        buy_type: 1,
        new_months: 1
      },
      formRules: {
        name: [
          {
            required: true,
            message: "请输入授权客户名称",
            trigger: "blur",
          },],
        code: [
          {
            required: true,
            message: "请输入授权码",
            trigger: "blur",
          },
          {
            pattern: /^[0-9a-zA-Z]{1,}$/,
            message: "只支持输入数字、字母",
            trigger: "blur",
          },],
        key: [
          {
            required: true,
            message: "请输入授权码密码",
            trigger: "blur",
          },
          {
            pattern: /^[0-9a-zA-Z]{1,}$/,
            message: "只支持输入数字、字母",
            trigger: "blur",
          },],
        contact_name: [
          {
            required: true,
            message: "请输入客户联系人",
            trigger: "blur",
          },],
        phone: [
          {
            required: true,
            message: "请输入联系人电话",
            trigger: "blur",
          },],
        email: [
          {
            required: true,
            message: "请输入联系人邮箱",
            trigger: "blur",
          },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: "blur",
          },],
      },
      isSelectAll: false,
      modules: [],
      buyTime: [
        { name: "一年", value: 12 },
        { name: "两年", value: 24 },
        { name: "三年", value: 36 },
        { name: "买断", value: 10000 },
      ],
      edittions: [],
      lockModuels: {}, //必须跟着版本购买的模块
      currentSelectModuels: [],
    };
  },
  mounted() {
    window.test = this;
  },
  methods: {
    changeBuyDate() {
      this.accreditDate();
    },
    accreditDate() {
      let date = new Date(this.form.expire_time);
      if (this.isAdd != "edit") {
        date = new Date();
        this.form.expire_time = `${date.getFullYear()}-${this.formatDate(
          date.getMonth() + 1
        )}-${this.formatDate(date.getDate())}`;
      }
      if (this.form.expire_time == "买断") {
        //过期时间为买断
        this.new_expire_time = "买断";
      } else if (this.form.expire_time && date >= new Date()) {
        //判断有过期时间并且在没过期时间范围内
        if (this.form.months === 0) {
          //购买时长为只购买模块
          this.new_expire_time = `${date.getFullYear()}-${this.formatDate(
            date.getMonth() + 1
          )}-${this.formatDate(date.getDate())}`;
        } else if (this.form.months === 10000) {
          //购买时长为买断
          this.new_expire_time = "买断";
        } else {
          //购买时长N(1)年
          date.setMonth(date.getMonth() + this.form.months);
          this.new_expire_time = `${date.getFullYear()}-${this.formatDate(
            date.getMonth() + 1
          )}-${this.formatDate(date.getDate())}`;
        }
      }
      //else{
      //   date = new Date()
      //   this.new_expire_time = `有效期至${date.getFullYear()}-${this.formatDate(date.getMonth()+1)}-${this.formatDate(date.getDate())}`
      // }
    },
    getBuyMonths(code) {
      if (!this.lockModuels[code]) {
        if (this.currentSelectModuels.indexOf(code) != -1) {
          if (this.form.expire_time) {
            let date = new Date(this.form.expire_time);
            let now = new Date();
            if (now < date) {
              //未过期
              return `${this.form.months}个月+补购${Math.floor(
                (date - now) / 86400000
              )}天`;
            }
          }
        }
      }
      return this.form.months + "个月";
    },
    formatDate(num) {
      let result = num + "";
      if (result.length < 2) {
        result = "0" + result;
      }
      return result;
    },
    show(obj) {
      this.form = {
        name: "",
        code: "",
        key: "",
        contact_name: "",
        phone: "",
        email: "",
        months: 12,
        pay_type: 1,
        fbi_edition: "",
        modules: [],
        note: "",
        buy_type: 1,
        new_months: 1
      };
      this.buyTime = [
        { name: "一年", value: 12 },
        { name: "两年", value: 24 },
        { name: "三年", value: 36 },
        { name: "买断", value: 10000 },
      ]
      this.visible = true;
      if (this.isAdd == "edit") {
        this.modifyId = obj.id;
        this.form.name = obj.name;
        this.form.code = obj.code;
        this.form.fbi_edition = obj.fbi_edition;
        this.form.expire_time = obj.expire_time;
        this.form.buy_type = 1
        this.form.new_months = 1
        // if(this.form.expire_time == "买断"){
        //   this.form.buy_type = 1
        // }else{
        //   console.log(obj.months)


        // }
        this.currentSelectModuels = obj.modules;
      } else if (this.isAdd == 'triall') {
        this.form.months = 30
      }
      this.accreditDate();
      this.getEditions();
    },
    triallClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let obj = {
            trail_days: this.form.months,
            fbi_edition: this.form.fbi_edition.id,
          };
          obj.name = this.form.name;
          obj.code = this.form.code;
          obj.key = this.form.key;
          obj.contact_name = this.form.contact_name;
          obj.phone = this.form.phone;
          obj.email = this.form.email;
          addTrail(obj)
            .then(() => {
              this.loading = false;
              this.$message({
                type: "success",
                message: "申请试用成功",
              });
              this.$parent.getAuthData();
              this.form = {
                name: "",
                code: "",
                key: "",
                contact_name: "",
                phone: "",
                email: "",
                months: null,
                pay_type: 1,
                fbi_edition: "",
                modules: [],
                note: "",
                buy_type: 1,
                new_months: 1
              },
                this.visible = false
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },

    buy_type_change(val) {
      // if (val == 2) {
      //   this.form.months = 1
      // }
    },
    buyClick() {
      this.$refs.form.validate((valid) => {
        console.log(this.form.fbi_edition);
        if (valid) {
          let buyout = false
          if (this.form.buy_type == 1) {
            buyout = true
            this.form.months = 10000
          } else {
            buyout = false
            this.form.months = Number(this.form.new_months) * 12
          }
          let obj = {
            months: this.form.months,
            pay_type: this.form.pay_type,
            fbi_edition: this.form.fbi_edition.id,
            // modules: this.currentSelectModuels.join(","),
          };
          obj.buyout = buyout
          if (this.isAdd == "add") {
            obj.name = this.form.name;
            obj.code = this.form.code;
            obj.key = this.form.key;
            obj.contact_name = this.form.contact_name;
            obj.phone = this.form.phone;
            obj.email = this.form.email;
            this.buySubmit(obj);
          } else if (this.isAdd == "edit") {
            this.modifyBuySubmit(obj);
          }
        }
      });
    },
    buySubmit(obj) {
      let priceObj = {
        pay_type: this.form.pay_type,
        months: this.form.months,
        fbi_edition: this.form.fbi_edition.id,
        buyout:obj.buyout
        // modules: this.currentSelectModuels.join(","),
      };
      buyPrice(priceObj)
        .then((res) => {
          this.$store
            .dispatch("user/userinfo") //获取账户余额
            .then(() => {
              this.loading = false;
              let finance = {
                special: this.$store.getters.userInfo.finance.fbi_point,
                universal: this.$store.getters.userInfo.finance.point,
              };
              let parms = {
                price: res.total,
                payType: this.form.pay_type,
              };
              let result = payVerify(parms, finance, 'FastBI产品'); //检测余额是否足够
              this.$confirm(`${result.msg}，是否购买？`, "支付信息", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  buy(obj).then((res) => {
                    this.$message({
                      type: "success",
                      message: "购买成功!",
                    });
                    this.visible = false;
                    this.$parent.getAuthData();
                  });
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "已取消购买",
                  });
                });
            });
        })
        .catch((err) => { });
    },
    modifyBuySubmit(obj) {
      let priceObj = {
        pay_type: this.form.pay_type,
        months: this.form.months,
        buyout:obj.buyout
        // modules: this.currentSelectModuels.join(","),
      };
      modify_price(this.modifyId, priceObj)
        .then((res) => {
          this.$store
            .dispatch("user/userinfo") //获取账户余额
            .then(() => {
              this.loading = false;
              let finance = {
                special: this.$store.getters.userInfo.finance.fbi_point,
                universal: this.$store.getters.userInfo.finance.point,
              };
              let parms = {
                price: res.total,
                payType: this.form.pay_type,
              };
              let result = payVerify(parms, finance, 'FastBI产品'); //检测余额是否足够
              this.$confirm(`${result.msg}，是否购买？`, "支付信息", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  modify(this.modifyId, obj).then((res) => {
                    this.$message({
                      type: "success",
                      message: "购买成功!",
                    });
                    this.visible = false;
                    this.$parent.getAuthData();
                  });
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "已取消购买",
                  });
                });
            });
        })
        .catch((err) => { });
    },
    restForm(done) {
      this.cancel();

      done();
    },
    cancel(formName, close) {
      this.form = {
        name: "",
        code: "",
        key: "",
        contact_name: "",
        phone: "",
        email: "",
        months: 12,
        pay_type: 1,
        fbi_edition: "",
        modules: [],
        note: "",
        buy_type: 1,
        new_months: 1
      };
      this.modifyId = null;
      this.isAdd = "add";
    },
    checkSelctRow(row) {
      if (row.code == this.lockModuels[row.code]) {
        return false;
      } else {
        return true;
      }
    },
    selectChange(selection, row) {
      this.currentSelectModuels = selection.map((val) => {
        return val.code;
      });
    },
    selectAllChange(selection) {
      this.currentSelectModuels = selection.map((val) => {
        return val.code;
      });
      //全选、反全选
      // this.isSelectAll = !this.isSelectAll;
      // if (this.isSelectAll == false) {
      //   this.$refs.elTable.clearSelection();
      // } else {
      //   selection.forEach((item) => {
      //     if (item.children) {
      //       item.children.forEach((item) => {
      //         this.$refs.elTable.toggleRowSelection(item, true);
      //       });
      //     }
      //   });
      // }
    },
    changeMonths(item) {
      console.log(item);
      if (item.buyout_valid && item.valid) {
        this.buyTime = [
          { name: "一年", value: 12 },
          { name: "两年", value: 24 },
          { name: "三年", value: 36 },
          { name: "买断", value: 10000 },
        ]
      } else if (item.buyout_valid) {
        this.buyTime = [
          { name: "买断", value: 10000 },
        ]
      } else if (item.valid) {

        this.buyTime = [
          { name: "一年", value: 12 },
          { name: "两年", value: 24 },
          { name: "三年", value: 36 }
        ]
      }
    },
    changeEditions(item) {
      this.changeMonths(item);
      if (this.$refs.elTable) {
        this.$refs.elTable.clearSelection();
        this.currentSelectModuels = [];
        this.lockModuels = {};
        if (item.modules) {
          item.modules.forEach((code) => {
            for (let index = 0; index < this.modules.length; index++) {
              const element = this.modules[index];
              if (element.code == code) {
                //arr.push(element)
                this.$refs.elTable.toggleRowSelection(element, true);
                this.lockModuels[code] = code;
                this.currentSelectModuels.push(code);
                break;
              }
            }
          });
        }
      }

    },
    getEditions() {
      getProductEditions()
        .then((response) => {
          this.edittions = response;
          // this.getModules(); //接着获取模块列表
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getModules() {
      getProductModules().then((res) => {
        this.modules = res;
        if (this.isAdd != "edit") {
          this.form.fbi_edition = { id: this.edittions[0].id };
          setTimeout(() => {
            this.changeEditions(this.edittions[0]);
          });
        } else {
          setTimeout(() => {
            this.changeEditions({ modules: this.currentSelectModuels });
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.buyDialog {
  div {
    // box-sizing: border-box;
  }

  /deep/ .el-dialog__body {
    padding: 30px 20px 0px 20px !important;
  }

  .info {
    margin: 10px 5px;
    border: 1px solid rgb(233, 233, 233);
    border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.047) 0px 0px 5px;

    .input_box {
      padding: 0 50px;
      margin-top: 20px;

      // margin-bottom: 10px;
      .block {
        display: inline-block;
        margin-right: 85px !important;
        margin-top: 0 !important;
        margin-bottom: 10px !important;
        width: 178px;

        .autocomplete {
          width: 100%;
        }

        .el-form-item {
          margin-bottom: 0px;
        }
      }

      .block:last-child {
        margin-right: 0 !important;
      }

      .label {
        margin-bottom: 5px;
        font-size: 13px;

        span {
          color: #ff0000;
        }
      }
    }

    .title {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      border-bottom: 1px solid rgb(233, 233, 233);
      font-size: 16px;
      font-weight: 650;
      padding: 15px 20px;
      background: #f9f9f9;
    }
  }

  .company_info {
    padding-bottom: 20px;
  }

  .authorization_info {
    .context {
      padding: 20px 50px;

      p {
        font-size: 13px;
        margin-bottom: 5px;
      }
    }
  }

  .pay_info {
    padding-bottom: 20px;
  }

  .price {
    float: left;
    text-align: left;
    font-size: 16px;

    span {
      color: #ff0000;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/product/buyProduct.vue